import { Typography } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'

/**
 * Intended to display the device of the ticket.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
export const ListItemCellTicketDevice = (classes, props = {}) => {
  const { itemData = {}, inverted = false } = props
  const { name, serial, serialDistinction } = itemData
  const serialValue = serialDistinction ?? serial ?? '-'
  const nameValue = name ?? '-'

  return (
    <>
      <Typography
        color={'black'}
        variant={'body2'}
        className={classes.row}
        sx={{ fontWeight: 700 }}
        title={!inverted ? nameValue : serialValue}
      >
        {!inverted ? nameValue : serialValue}
      </Typography>
      <Typography
        variant={'caption'}
        className={classes.row}
        color={'textSecondary'}
        title={!inverted ? serialValue : nameValue}
      >
        {!inverted ? serialValue : nameValue}
      </Typography>
    </>
  )
}

export default CellHOC(ListItemCellTicketDevice)
